import { jsx as _jsx } from "react/jsx-runtime";
export const Colour = ({ value, onChange }) => {
    return (_jsx("input", { type: "color", className: "", value: value, onChange: (event) => (onChange) ? onChange(event) : null })
    // <SketchPicker
    //   color={value}
    //   onChange={(color) =>
    //     onChange
    //       ? onChange({
    //           target: { value: color.hex },
    //         } as ChangeEvent<HTMLInputElement>)
    //       : null
    //   }
    // />
    );
};
